import fetchAx from "@/axios.js";
export default {
  namespaced: true,
  state: {
    sebepKodAd: [],
    operatorNumber: 0,
    scadaData: [],
    section: [],
    stand: [],
    plc: [],
    type: "",
    sectionConnectStatus: [],
    jobOrder: [],
    selectedStand: null,
    cycleTime: 0,
    selectedBarcode: "",
    productionQuantity: 0,
    unitsProduced: 0,
    selectedSection: null,
    plcStatus: "D",
    momentaryStopTime: 0,
    stopTime: 0,
    dynamicCycleTime: 0,
    totalCycleTime: 0,
    lastTime: 0,
    shiftStopTime: 0,
    shiftUnitsProduced: 0,
    shiftTotalCycleTime: 0,
    shiftName: "",
    shiftTime: 0,
    plcBuzzer: [],
    allStands: [],
    fireList: [],
    shiftTotalUnit: 0,
    lastReadTime: null,
  },
  mutations: {
    setLastReadTime(state, payload) {
      state.lastReadTime = payload;
    },
    setShiftTotalUnit(state, payload) {
      state.shiftTotalUnit = payload || 0;
    },
    setFireList(state, payload) {
      state.fireList = payload;
    },
    setOperatorNumber(state, payload) {
      state.operatorNumber = payload;
    },
    setPlcBuzzer(state, payload) {
      state.plcBuzzer = payload;
    },
    resetData(state) {
      state.plcStatus = "D";
      state.stopTime = 0;
      state.momentaryStopTime = 0;
      state.totalCycleTime = 0;
      state.lastTime = 0;
      state.dynamicCycleTime = 0;
      state.unitsProduced = 0;
      state.productionQuantity = 0;
    },
    setShiftStopTime(state, payload) {
      state.shiftStopTime = payload;
    },
    setShiftUnitsProduced(state, payload) {
      state.shiftUnitsProduced = payload;
    },
    setShiftTotalCycleTime(state, payload) {
      state.shiftTotalCycleTime = payload;
    },
    setShiftName(state, payload) {
      state.shiftName = payload;
    },
    setShiftTime(state, payload) {
      state.shiftTime = payload;
    },
    setLastTime(state, payload) {
      state.lastTime = payload;
    },
    resetSelectedBarcode(state, payload) {
      state.selectedBarcode = "";
    },
    setTotalCycleTime(state, payload) {
      state.totalCycleTime = payload;
    },
    setMomentaryStopTime(state, payload) {
      state.momentaryStopTime = payload;
    },
    setStopTime(state, payload) {
      state.stopTime = payload;
    },
    setPlcStatus(state, payload) {
      state.plcStatus = payload;
    },
    setDynamicCycleTime(state, payload) {
      state.dynamicCycleTime = payload;
    },
    resetUnitsProduced(state) {
      state.unitsProduced = 0;
      state.jobOrder = [];
    },
    setSelectedSection(state, payload) {
      state.selectedSection = payload;
    },
    setUnitsProduced(state, payload) {
      state.unitsProduced = payload;
    },
    setPlc(state, payload) {
      state.type = "plc";
    },
    setType(state, payload) {
      state.type = payload;
    },
    getBack(state) {
      if (state.type == "stand") {
        state.stand = [];
        state.plc = [];
        state.type = "section";
      } else if (state.type == "plc") {
        state.plc = [];
        state.type = "stand";
      } else if (state.type == "stop" || state.type == "productionMove") {
        state.type = "plc";
      }
    },
    setStand(state, payload) {
      state.type = "stand";
      state.stand = state.scadaData.filter((sec) => {
        return sec.PLC_KOD == payload.PLC_KOD;
      });
      state.allStands = state.stand.map((stand) => ({
        tezgahKod: stand.TEZGAH_KOD,
        adet: 0,
        statu: "G",
      }));
    },
    setScadaData(state, payload) {
      state.scadaData = payload;
    },
    setSection(state) {
      // state.section = [...new Set(state.scadaData.map((item) => item.BOLUM))];
      const section = [];
      state.scadaData.forEach((scada) => {
        if (!section.find((section) => section.PLC_KOD == scada.PLC_KOD)) {
          section.push({ BOLUM: scada.BOLUM, PLC_KOD: scada.PLC_KOD });
        }
      });
      state.section = section;
    },
    setSectionConnectStatus(state, payload) {
      const scada = [];
      payload.forEach((data) => {
        const element = data.user;
        const matchedScada = state.scadaData.find((scada) => {
          return scada.PLC_KOD == element.erpStaffNo;
        });
        if (
          matchedScada &&
          !scada.find((scada) => {
            return scada.PLC_KOD == element.erpStaffNo;
          })
        ) {
          scada.push({
            BOLUM: matchedScada.BOLUM,
            PLC_KOD: matchedScada.PLC_KOD,
          });
        }
      });
      state.sectionConnectStatus = scada;
    },
    setStandCode(state, payload) {
      state.standCode = paylaod;
    },
    setJobOrder(state, payload) {
      state.jobOrder = payload;
    },
    setSelectedStand(state, payload) {
      state.selectedStand = payload;
    },
    setSelectedBarcode(state, payload) {
      state.selectedBarcode = payload;
    },
    setCycleTime(state, payload) {
      state.cycleTime = payload;
    },
    setProductionQuantity(state, payload) {
      state.productionQuantity = payload;
    },
    setAllStandStats(state, payload) {
      const { adet, kod, statu } = payload;
      const index = state.allStands.findIndex(
        (stand) => stand.tezgahKod == kod
      );
      if (index !== -1) {
        state.allStands[index].adet = adet;
        state.allStands[index].statu = statu;
      }
    },
    setSebepKodAd(state, payload) {
      state.sebepKodAd = payload;
    },
    resetStand(state) {
      state.stand = [];
    },
  },
  getters: {
    getLastReadTime: (state) => state.lastReadTime,
    getFireList: (state) => state.fireList,
    getSebepKodAd: (state) => state.sebepKodAd,
    getOperatorNumber: (state) => state.operatorNumber,
    getAllStands: (state) => state.allStands,
    getPlcBuzzer(state) {
      return state.plcBuzzer.filter((buzzer) => {
        return buzzer.TEZGAH == state.selectedStand;
      });
    },
    getSelectedStandName(state) {
      return state.stand.find((stand) => {
        return stand.TEZGAH_KOD == state.selectedStand;
      }).TEZGAH_AD;
    },
    getShiftTotalUnit: (state) => state.shiftTotalUnit,
    getShiftTotalCycleTime: (state) => state.shiftTotalCycleTime,
    getShiftStopTime: (state) => state.shiftStopTime,
    getShiftTime: (state) => state.shiftTime,
    getShiftUnitsProduced: (state) => state.shiftUnitsProduced,
    getShiftName: (state) => state.shiftName,
    getSectionConnectStatus: (state) => state.sectionConnectStatus,
    getStand: (state) => state.stand,
    getSection: (state) => state.section,
    getType: (state) => state.type,
    getStandCode: (state) => state.standCode,
    getJobOrder: (state) => state.jobOrder,
    getSelectedStand: (state) => state.selectedStand,
    getSelectedBarcode: (state) => state.selectedBarcode,
    getCycleTime: (state) => state.cycleTime,
    getProductionQuantity: (state) => state.productionQuantity,
    getUnitsProduced: (state) => state.unitsProduced,
    getPlcStatus: (state) => state.plcStatus,
    getMomentaryStopTime: (state) => state.momentaryStopTime,
    getStopTime: (state) => state.stopTime,
    getDynamicCycleTime: (state) => state.dynamicCycleTime,
    getTotalCycleTime: (state) => state.totalCycleTime,
    getLastTime: (state) => state.lastTime,
    getSelectedSection: (state) => state.selectedSection,
  },
  actions: {
    async fetchScada({ commit }) {
      const kriterler = {
        queryKey: "PLC_BolumleriGetir",
      };
      await fetchAx
        .post("v1/Dynamic/GetQueryReplaceData", kriterler)
        .then((response) => {
          commit("setScadaData", JSON.parse(response.data.data.dataJson));
          commit("setSection");
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    async fetchJobOrders({ state, commit, dispatch }, barcode) {
      if (barcode !== 0) {
        const kriterler = {
          queryKey: "LogoUretimEmirleriniGetir",
          metin1: state.selectedStand,
          metin2: barcode,
        };
        return new Promise(async (resolve, reject) => {
          await fetchAx
            .post("v1/Dynamic/GetQueryReplaceData", kriterler)
            .then((response) => {
              if (JSON.parse(response.data.data.dataJson).length > 0) {
                resolve({
                  status: 200,
                  cycleTime: JSON.parse(response.data.data.dataJson)[0]
                    .CEVRIM_SURE,
                  jobOrder: JSON.parse(response.data.data.dataJson)[0]
                    .IS_EMRI_MIKTARI,
                  productCode: JSON.parse(response.data.data.dataJson)[0]
                    .ANA_URUN_KODU,
                  product: JSON.parse(response.data.data.dataJson)[0]
                    .ANA_URUN_ACIK,
                });
                commit("setJobOrder", JSON.parse(response.data.data.dataJson));
              } else {
                resolve({ status: 204 });
              }
            })
            .catch((error) => {
              console.error("Error fetching data:", error);
              reject({ status: 400 });
            });
        });
      }
    },
    async fetchPlcBuzzer({ commit }) {
      const kriterler = {
        queryKey: "PLCBuzzerTest",
      };
      await fetchAx
        .post("v1/Dynamic/GetQueryReplaceData", kriterler)
        .then((response) => {
          commit("setPlcBuzzer", JSON.parse(response.data.data.dataJson));
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    async sendFire({ state }, payload) {
      let kriterler = {
        queryKey: "ScadaFireGirisSorgusu",
        metin1: state.selectedBarcode,
        metin2: payload.miktar,
        metin3: payload.tarih,
        metin4: payload.sebep.SEBEPKOD,
        metin5: payload.sebep.SEBEPAD,
        metin6: payload.aciklama,
      };
      return new Promise(async (resolve, reject) => {
        await fetchAx
          .post("v1/Dynamic/GetQueryReplaceData", kriterler)
          .then((response) => {
            const data = JSON.parse(response.data.data.dataJson);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
            console.error("Error fetching data:", error);
          });
      });
    },
    async fetchFireSebep({ commit }, payload) {
      let kriterler = {
        queryKey: "ScadaFireSebepleriGetir",
      };

      return new Promise(async (resolve, reject) => {
        await fetchAx
          .post("v1/Dynamic/GetQueryReplaceData", kriterler)
          .then((response) => {
            const data = JSON.parse(response.data.data.dataJson);
            commit("setSebepKodAd", data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
            console.error("Error fetching data:", error);
          });
      });
    },
    async fetchFire({ commit, state }, payload) {
      let kriterler = {
        queryKey: "ScadaFireleriGetirKriterli",
        metin1: state.selectedBarcode,
      };

      return new Promise(async (resolve, reject) => {
        await fetchAx
          .post("v1/Dynamic/GetQueryReplaceData", kriterler)
          .then((response) => {
            const data = JSON.parse(response.data.data.dataJson);
            commit("setFireList", data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
            console.error("Error fetching data:", error);
          });
      });
    },
  },
};
